import { AfterContentInit, AfterViewInit, Injectable, OnDestroy, OnInit } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppConfigService } from './app-config.service';
import { environment } from "src/environments/environment";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string | any;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService{
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  //app-config
  baseUrl = environment.basicUrl
  isYamama = this.appConfigService?.isYamama();
  isAjial = this.appConfigService?.isAjial();

  constructor(private router: Router, public translate: TranslateService, private appConfigService: AppConfigService) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      title: 'Dashboard',
      icon: "home",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "1",
      active: true,
      children: [
        { path: "/dashboard/default", title: "Home", type: "link" },
      ],
    },
    {
      title: 'EnrollmentRequestsModule.Enrollment Requests',
      icon: "table",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "2",
      active: false,
      children: [
        { path: "/enrollment", title: "EnrollmentRequestsModule.Register New Enrollment Request", type: "link" },
        { path: "/enrollment/pending-enrollment-requests", title: "EnrollmentRequestsModule.Pending Enrollment Requests", type: "link" },
      ],
    },
    // {
    //   title: 'UpgradeRequestsModule.Upgrade Requests',
    //   icon: "learning",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   badgeValue: "2",
    //   active: false,
    //   children: [
    //     { path: "/upgrade/upgrade-requests", title: "UpgradeRequestsModule.Create Upgrade Request", type: "link" },
    //     { path: "/upgrade/upgrade-requests-list", title: "UpgradeRequestsModule.Pending Upgrade Requests", type: "link" },
    //   ],
    // },
    // {
    //   title: 'WithdrawalRequestsModule.Withdrawal Requests',
    //   icon: "sample-page",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   badgeValue: "2",
    //   active: false,
    //   children: [
    //     { path: "/withdrawal/requests", title: "WithdrawalRequestsModule.New Requests", type: "link" },
    //     { path: "/withdrawal/transport", title: "WithdrawalRequestsModule.Withdrawal Transportation", type: "link" },
    //   ],
    // },
    // {
    //   title: 'TransferModule.Transformation Requests',
    //   icon: "job-search",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   badgeValue: "1",
    //   active: false,
    //   children: [
    //     { 
    //       path: "/transformation/transfer-requests", 
    //       title: "TransferModule.Pending Transfer Requests", 
    //       type: "link"
    //     },
    //   ],
    // },
    // {
    //   title: 'Transportation.Transportation',
    //   icon: "maps",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   badgeValue: "2",
    //   active: false,
    //   children: [
    //     { path: "/transportation", title: "Forms.Transportation Subscription", type: "link" },
    //     { path: "/transportation/pending-transportation-requests", title: "Transportation.Pending Transportation Requests", type: "link" },
    //   ],
    // },
    // {
    //   path: "/notifications/notifications",
    //   title: 'Notifications.Notifications',
    //   icon: "email",
    //   type: "link",
    // },
    {
      title: 'DebtsModule.Debts',
      icon: "sample-page",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "1",
      active: false,
      children: [
        { path: "/debts", title: "DebtsModule.All Debts", type: "link" },
        // { path: "/debts/all-parent-bills", title: "DebtsModule.Child Debts", type: "link" },
      ],
    },
    {
      title: 'DiscountsModule.Discounts And Offers',
      icon: "job-search",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "2",
      active: false,
      children: [
        { path: "/discounts/company-discount", title: "DiscountsModule.Company Discount", type: "link" },
        { path: "/discounts/siblings-discount", title: "DiscountsModule.Siblings Discount", type: "link" },
      ],
    },
    {
      path: "/child",
      title: 'Child.Child',
      icon: "user",
      type: "link",
    },
    {
      title: 'CRMModule.CRM',
      icon: "support-tickets",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "2",
      active: false,
      children: [
        { path: "/CRM/my-tickets", title: "CRMModule.My Tickets", type: "link" },
        { path: "/CRM/create-complaint", title: "CRMModule.Create Complaint", type: "link" },
      ],
    },
    {
      title: 'SuggestionsModule.Suggestions  Management',
      icon: 'icons',
      type: 'sub',
      badgeType: 'light-primary',
      badgeValue: "1",
      active: false,
      children: [
        {
          path: '/suggestions/suggestions',
          title: 'SuggestionsModule.Suggestions',
          type: 'link',
        },
      ],
    },
    {
      title: 'QuestionsModule.Questionnaires  Management',
      icon: 'icons',
      type: 'sub',
      badgeType: 'light-primary',
      active: false,
      children: [
        {
          path: '/questionnaires/list',
          title: 'QuestionsModule.Questionnaires',
          type: 'link',
        },
      ],
    },
    // {
    //   path: "market",
    //   title: 'Market.Market',
    //   icon: "ecommerce",
    //   type: "link",
    // },
    // {
    //   path: "inquiries",
    //   title: 'Inquiries.Inquiries',
    //   icon: "faq",
    //   type: "link",
    // },
    // {
    //   path: "extracts",
    //   title: 'Extracts.Extracts',
    //   icon: "bonus-kit",
    //   type: "link",
    // },
    {
      path: "terms/terms-and-conditions",
      title: 'Terms And Conditions',
      icon: "editors",
      type: "link",
    },
    // {
    //   title: 'ContactUs.Contact Us',
    //   icon: "contact",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   badgeValue: "2",
    //   active: false,
    //   children: [
    //     { path: "/contact-us/management", title: "ContactUs.Management", type: "link" },
    //     { path: "/contact-us/teacher", title: "ContactUs.Teacher", type: "link" },
    //   ],
    // }
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
